import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { base_url } from '../context/Authcontext';
import "../assets/AdminCss/TennisScoreboard.css";

const TennisScoreboard = () => {
  const [player1Score, setPlayer1Score] = useState({
    sets: [4, 4],
    currentGame: 40,
    aces: 0,
    doubleFaults: 0,
    serviceBreaks: 0
  });
  
  const [player2Score, setPlayer2Score] = useState({
    sets: [2, 7],
    currentGame: 30,
    aces: 0,
    doubleFaults: 0,
    serviceBreaks: 0
  });
  
  const [matches, setMatches] = useState([]);
  
  const player1 = sessionStorage.getItem('runner1') || 'Sofia Kenin';
  const player2 = sessionStorage.getItem('runner2') || 'Bernarda Pera';

  const fetchScore = useCallback(async () => {
    const eventid = sessionStorage.getItem('eventid');
    try {
      const response = await axios.post(base_url + '/api/webapi/scoreboard', 
        { eventid },
        { headers: { 'content-type': 'application/json' } }
      );
      const matchData = response?.data.result;

      if (matchData) {
        const matchParseData = JSON.parse(matchData);
        
        // Format match data for tennis
        const formattedMatch = {
          player1: matchParseData.h || player1,
          player2: matchParseData.a || player2,
          player1Score: {
            sets: [matchParseData.hs?.[0]?.set1 || 4, matchParseData.hs?.[0]?.set2 || 4],
            currentGame: matchParseData.hs?.[0]?.currentGame || 40,
            aces: matchParseData.hs?.[0]?.aces || 0,
            doubleFaults: matchParseData.hs?.[0]?.doubleFaults || 0,
            serviceBreaks: matchParseData.hs?.[0]?.serviceBreaks || 0
          },
          player2Score: {
            sets: [matchParseData.as?.[0]?.set1 || 2, matchParseData.as?.[0]?.set2 || 7],
            currentGame: matchParseData.as?.[0]?.currentGame || 30,
            aces: matchParseData.as?.[0]?.aces || 0,
            doubleFaults: matchParseData.as?.[0]?.doubleFaults || 0,
            serviceBreaks: matchParseData.as?.[0]?.serviceBreaks || 0
          },
          expanded: true,
        };

        // Update state with match data
        setPlayer1Score(formattedMatch.player1Score);
        setPlayer2Score(formattedMatch.player2Score);
        setMatches([formattedMatch]);
      }
    } catch (err) {
      console.log(err);
    }
  }, [player1, player2]);

  useEffect(() => {
    fetchScore();
    const intervalId = setInterval(fetchScore, 5000);
    
    return () => clearInterval(intervalId);
  }, [fetchScore]);

  return (
    <div className="scoreboard-container">
      <div className="scoreboard-header">
        Score Board
      </div>
      <div className="overAllTennis">
        {/* Main Scoreboard */}
        <div className="scoreboard-pitchs">
          {/* Player 1 */}
          <div className="player-row">
            <div className="player-name">{matches?.[0]?.player1 || player1}</div>
            <div className="set-scores">
              <div className="set-score">{player1Score.sets[0]}</div>
              <div className="set-score">{player1Score.sets[1]}</div>
              <div className="set-score"></div>

              <div className="game-score">{player1Score.currentGame}</div>
              <div className="set-score"></div>
              <div className="set-score"></div>
              <div className="current-point">{player1Score.serviceBreaks}</div>
            </div>
          </div>

          {/* Player 2 */}
          <div className="player-row">
            <div className="player-name">{matches?.[0]?.player2 || player2}</div>
            <div className="set-scores">
              <div className="set-score">{player2Score.sets[0]}</div>
              <div className="set-score">{player2Score.sets[1]}</div>
              <div className="set-score"></div>
              <div className="game-score">{player2Score.currentGame}</div>
              <div className="set-score"></div>
              <div className="set-score"></div>
              <div className="current-point">{player2Score.serviceBreaks}</div>
            </div>
          </div>

          {/* Stats header */}
          <div className="stats-header">
            <div className="stat-label">Players</div>
            <div className="stat-label">1</div>
            <div className="stat-label">2</div>
            <div className="stat-label">3</div>
            <div className="stat-label">Points</div>
            <div className="stat-label">Aces</div>
            <div className="stat-label">Double Faults</div>
            <div className="stat-label">Service Breaks</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TennisScoreboard;